"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
// Relements
var modal_1 = __importDefault(require("relements/build/esm/overlays/modal"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var BinIcon_1 = __importDefault(require("relements/build/esm/ui/icons/BinIcon"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var loader_1 = __importDefault(require("relements/build/esm/ui/loader"));
var UploadIconV2_1 = __importDefault(require("relements/build/esm/ui/icons/UploadIconV2"));
var upload_1 = require("relements/build/esm/api/upload");
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
// actions
var BotActions_1 = require("@src/actions/BotActions");
var selectors_1 = require("@src/reduxStores/business/selectors");
// Global Component
var const_1 = require("./const");
var StyledComponets_1 = require("./StyledComponets");
var selectors_2 = require("../store/selectors");
var api_1 = require("../store/api");
var InputLabel = function (_a) {
    var _b = _a.primaryText, primaryText = _b === void 0 ? '' : _b, _c = _a.secondaryText, secondaryText = _c === void 0 ? '' : _c;
    return (react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold", color: "black.haptik" },
        primaryText,
        react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.deep" },
            "\u00A0",
            secondaryText)));
};
var ACCEPT_TYPES = ['application/pdf'];
var GenAiCreateCodeNodeModal = function (_a) {
    var active = _a.active, onClose = _a.onClose, agentId = _a.agentId, setIsActionGenerationInProgress = _a.setIsActionGenerationInProgress;
    var modalRef = react_1.useRef(null);
    var fileInputRef = react_1.useRef(null);
    var _b = react_1.useState(const_1.fieldList), inputFields = _b[0], setInputFields = _b[1];
    var businessId = react_redux_1.useSelector(selectors_1.getBusinessId);
    var domainId = react_redux_1.useSelector(selectors_2.getDomainId);
    var _c = react_1.useState(false), isUploading = _c[0], setIsUploading = _c[1];
    var _d = react_1.useState({ name: '', url: '' }), uploadedFile = _d[0], setUploadedFile = _d[1];
    var _e = react_1.useState(''), uploadingError = _e[0], setUploadingError = _e[1];
    var validateFile = function (allowedFileTypes, file, fileType) {
        var isValid;
        var error = '';
        var fileSizeInMB = file.size / (1024 * 1024);
        if (fileSizeInMB > 5) {
            error = 'File size exceeds the 5MB limit. Please upload a smaller file.';
            return { isValid: false, error: error };
        }
        if (fileType === '') {
            isValid = file.name.includes('.pdf');
        }
        else {
            isValid = allowedFileTypes.includes(fileType);
        }
        if (!isValid) {
            error = 'Invalid file type. Please upload a PDF or TXT file.';
        }
        return { isValid: isValid, error: error };
    };
    var resetFields = function () {
        setInputFields(const_1.fieldList);
        setUploadedFile({ name: '', url: '' });
        setUploadingError('');
        setIsUploading(false);
        if (fileInputRef.current) {
            // Clear the native file input so the same file can be re-selected later
            fileInputRef.current.value = '';
        }
    };
    var handleFileUpload = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var file, _a, isValid, error;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    file = (_b = e.target.files) === null || _b === void 0 ? void 0 : _b[0];
                    if (!file)
                        return [2 /*return*/];
                    _a = validateFile(ACCEPT_TYPES, file, file.type), isValid = _a.isValid, error = _a.error;
                    if (uploadingError)
                        setUploadingError('');
                    if (!isValid) {
                        setUploadingError(error);
                        return [2 /*return*/];
                    }
                    setIsUploading(true);
                    return [4 /*yield*/, upload_1.uploadFile(file, function () { }, function (result) {
                            setUploadedFile({ url: result, name: file.name });
                            setIsUploading(false);
                        }, function (error) {
                            console.log({ error: error });
                            setUploadingError('Error uploading file.');
                            setIsUploading(false);
                            BotActions_1.createAlert('Error uploading file.', '', MogamboConstants_1.AlertTypes.NEGATIVE);
                        }, businessId, 1)];
                case 1:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(modal_1["default"], { themed: true, active: active, ref: modalRef, maxHeight: "800px", padding: "0px", footerBorder: false, onClose: function () {
                onClose();
                resetFields();
            } },
            react_1["default"].createElement(box_1["default"], { flexDirection: "column", width: "75vw", padding: "2px 8px 0px 8px", style: { maxWidth: '844px' } },
                react_1["default"].createElement("img", { src: const_1.AI_CODE_NODE_BANNER_URL }),
                (inputFields || []).map(function (_a, i) {
                    var label = _a.label, value = _a.value, isMultiline = _a.isMultiline, placeholder = _a.placeholder, error = _a.error, minHeight = _a.minHeight;
                    return (react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", marginTop: "20px" },
                        react_1["default"].createElement(box_1["default"], { padding: "0" },
                            react_1["default"].createElement(InputLabel, { primaryText: label.primaryText, secondaryText: label.secondaryText }),
                            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "red.haptik" }, "*")),
                        react_1["default"].createElement(StyledComponets_1.StyledTextInput, { isMultilineError: !!error, error: isMultiline ? false : error, placeholder: placeholder, multilineMinHeight: minHeight || '110px', themed: true, value: value, label: "", marginTop: "8px", multiline: isMultiline, onChange: function (val) {
                                var copyFields = JSON.parse(JSON.stringify(inputFields));
                                copyFields[i].value = val.trim();
                                copyFields[i].error = '';
                                setInputFields(copyFields);
                            }, style: { minHeight: minHeight } })));
                }),
                react_1["default"].createElement(box_1["default"], { padding: "0", marginTop: "16px", alignItems: "center", style: { gap: '8px' } },
                    react_1["default"].createElement(box_1["default"], { alignItems: "center", justifyContent: "space-between", backgroundColor: "lightgray", width: "150px", position: "relative", style: {
                            cursor: isUploading ? 'not-allowed' : 'pointer',
                            borderRadius: '4px',
                        }, onClick: function (e) {
                            var _a;
                            if (isUploading)
                                return;
                            (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
                            e.stopPropagation();
                        } },
                        react_1["default"].createElement(text_1["default"], { variant: "body.md" }, "Attach any file here"),
                        react_1["default"].createElement(UploadIconV2_1["default"], null),
                        react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "red.haptik" }, "*"),
                        react_1["default"].createElement(StyledComponets_1.StyledInput, { ref: fileInputRef, onChange: handleFileUpload, type: "file", accept: ACCEPT_TYPES.join(',') })),
                    uploadedFile.url && (react_1["default"].createElement(box_1["default"], { padding: "0", alignItems: "center", style: { gap: '8px' } },
                        react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "black.haptik", style: { marginTop: '4px' } }, uploadedFile.name),
                        react_1["default"].createElement(box_1["default"], { padding: "0", onClick: function () {
                                setUploadedFile({ name: '', url: '' });
                                // Clear the underlying file input element as well
                                if (fileInputRef.current) {
                                    fileInputRef.current.value = '';
                                }
                            }, width: "16px", height: "16px", style: { cursor: 'pointer' } },
                            react_1["default"].createElement(BinIcon_1["default"], { size: "small", iconColor: "red.haptik" })))),
                    uploadingError && (react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "red.haptik", marginTop: "4px" }, uploadingError)),
                    isUploading && (react_1["default"].createElement("div", { className: "" },
                        react_1["default"].createElement(loader_1["default"], null)))),
                react_1["default"].createElement(box_1["default"], { width: "100%", padding: "0px ", borderTop: "1px solid var(--relements-color-border-light)", display: "flex", justifyContent: "flex-end", gap: "8px", mt: "20px" },
                    react_1["default"].createElement(StyledComponets_1.StyledButton, { themed: true, width: "150px", height: "44px", fontSize: "15px", style: { marginRight: '0px' }, variant: inputFields.some(function (field) { return !field.value; }) || !uploadedFile.url
                            ? 'disabled'
                            : 'primary', disabled: inputFields.some(function (field) { return !field.value; }) || !uploadedFile.url, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                            var response;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, api_1.createCodeNodeAction(agentId, {
                                            action_description: inputFields[0].value,
                                            code_generation_instructions: inputFields[1].value,
                                            reference_document_url: uploadedFile.url || '',
                                            domain_id: domainId,
                                        })];
                                    case 1:
                                        response = _a.sent();
                                        if (response.success) {
                                            onClose();
                                            setIsActionGenerationInProgress(true);
                                            resetFields();
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); } }, "Generate Action"))))));
};
exports["default"] = GenAiCreateCodeNodeModal;
